import React from 'react';
import PropTypes from 'prop-types';
import getAssignmentStatus from './status';

const propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

function AssignmentStatus({
  status = '',
  className = 'tv-workassignment__item-status',
  statusName,
  children = null,
}) {
  const item = getAssignmentStatus(status);
  return (
    <div className={className}>
      {children}
      <span
        className={`tv-workassignment__status tv-workassignment__status--${status}`}
      >
        {statusName}
      </span>
    </div>
  );
}

AssignmentStatus.propTypes = propTypes;

export default AssignmentStatus;
